export default __webpack_public_path__ + "static/media/Weekly.13f1799d.svg";